
export default {
  name: 'EleTag',
  props: {
    closable: Boolean,
    color: String,
    size: {
      type: String,
      default: 'mini',
      validator: function (value) {
        return ['large', 'middle', 'small', 'mini'].indexOf(value) !== -1;
      }
    },
    shape: {
      type: String,
      default: 'default',
      validator: function (value) {
        return ['round', 'default', 'circle'].indexOf(value) !== -1;
      }
    }
  },
  emits: ['close'],
  computed: {
    tagClass() {
      return [
        'ele-tag',
        {'ele-tag-round': this.shape === 'round'},
        {'ele-tag-circle': this.shape === 'circle'},
        {'ele-tag-lg': this.size === 'large'},
        {'ele-tag-md': this.size === 'middle'},
        {'ele-tag-mini': this.size === 'mini'}
      ];
    }
  },
  methods: {
    /* close事件 */
    onClose(e) {
      this.$emit('close', e);
    }
  }
}
